import { APP_PERMISSION_TYPES } from "@lhd/constants";
import { Date, Orgs, Position, Worker, OrgNode } from ".";

export type Permission = Date & {
  id: number;
  org_ids: string;
  org_node_ids: string;
  custom_organizations: string[];
  worker_id: string;
  position_id: string;
  permission_type: keyof typeof APP_PERMISSION_TYPES;
  created_at: string;
  updated_at: string;
  company_id: string;
  target_type: string;
  app_id: number;
  app_record_id: number;
  orgs: Orgs[];
  org_nodes: OrgNode[];
  position: Position;
  worker: Worker;
  is_enabled: boolean;
  course_id?: number | null;
};

export enum PermissionType {
  CAN_VIEW = "can_view",
  CAN_EDIT = "can_edit",
  CAN_DELETE = "can_delete",
}

export type CompanyPermission = {
  company_id: number;
  created_at: string;
  id: number;
  is_unrestricted: boolean;
  org_node_ids: string | null;
  permission_type: PermissionType;
  position_ids: string | null;
  target_tab: string;
  updated_at: string;
  worker_ids: string | null;
  custom_organizations: string | null;
};

export type PermissionsCompanyResponse = {
  company_delete: string[];
  company_edit: string[];
  company_view: string[];
};

type PermissionDetail = {
  can_view: boolean;
  can_edit: boolean;
  can_delete: boolean;
  general_edit: boolean;
  general_delete: boolean;
};

export type CurrentUserPermissions = {
  is_admin: boolean;
  permissions: {
    company_policies?: PermissionDetail;
    role_permissions?: PermissionDetail;
    labor_documents?: PermissionDetail;
    financial_reports?: PermissionDetail;
    employment_contracts?: PermissionDetail;
    agreements?: PermissionDetail;
    business_flowcharts?: PermissionDetail;
    business_manuals?: PermissionDetail;
  };
};

export type CompanyPolicyPermission = {
  id: number;
  company_id: number;
  core_app_record_id: number;
  permission_type: string;
  target_type: string;
  is_enabled: boolean;
  is_unrestricted: boolean;
  position_ids: string | null;
  worker_ids: string | null;
  org_node_ids: string | null;
  custom_organizations: string | null;
  created_at: string;
  updated_at: string;
};

export type CompanyPolicyPermissionRecord = {
  id: number;
  app_id: number;
  company_policy_permissions: CompanyPolicyPermission[];
  regular_values: {
    app_part_id: number;
    id: number;
    value?: string;
  }[];
};

export type CompanyPolicyPermissionInput = {
  create?: {
    core_app_record_id: number;
    permission_type: 1 | 2 | 3;
    is_unrestricted: boolean;
    worker_ids?: string[];
    custom_organizations?: string[];
    position_ids?: string[];
  }[];
  delete?: {
    id: number;
  }[];
  update?: {
    id: number;
    permission_type: 1 | 2 | 3;
    is_unrestricted: boolean;
    worker_ids?: string[];
    custom_organizations?: string[];
    position_ids?: string[];
  }[];
};

export type InternalControlRecordPermissionsForm = Omit<
  CompanyPolicyPermissionRecord,
  "company_policy_permissions"
> & {
  internal_control_record_permissions: CompanyPolicyPermission[];
  display_name?: string;
};
